import { useEffect, useState } from "react";
import { useBaseAction } from "hooks/core";
import { ICustomReactSelectOption } from "core/types/elements/ICustomReactSelectOption";
import { IRoleApiResponse } from "core/types/base/IRole";

type TProps = {
  fetchOnLoad: boolean;
};

const useUserRoles = ({ fetchOnLoad }: TProps) => {
  const { request } = useBaseAction();
  const [roles, setRoles] = useState<ICustomReactSelectOption[]>([] as ICustomReactSelectOption[]);

  const getRoles = async () => {
    const data = (await request({
      method: "GET",
      url: "/Roles",
      useLoader: true,
    })) as IRoleApiResponse[];

    const roleOptions =
      data.map(role => ({
        value: role.name, // Use role name as value
        label: role.name, // Use role name as label
      })) || [];
    setRoles(roleOptions);
  };

  useEffect(() => {
    if (fetchOnLoad) getRoles();
  }, []);

  return {
    getRoles,
    roles,
  };
};

export default useUserRoles;
